import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { forwardRef } from "react";
export const ButtonGroup = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("flex gap-px ui2:gap-0 [&>*:first-child]:rounded-bl-4 [&>*:first-child]:rounded-tl-4 ui2:[&>*:first-child]:rounded-bl-8 ui2:[&>*:first-child]:rounded-tl-8 [&>*:last-child]:rounded-br-4 [&>*:last-child]:rounded-tr-4 ui2:[&>*:last-child]:rounded-br-8 ui2:[&>*:last-child]:rounded-tr-8 ui2:[&>*:not(:first-child)]:border-l-0 [&>*]:rounded-none ui2:[&>*]:rounded-none", className),
        ...restOfProps,
        ref: forwardedRef
    });
});
ButtonGroup.displayName = "ButtonGroup";
